import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/AcunMedya-Logo.png";
import "./LoginPage.css";

// ⭐ FIRESTORE IMPORTS
import {
  doc,
  getDoc,
  setDoc,
  query,
  where,
  collection,
  getDocs
} from "firebase/firestore";

// ⭐ AUTH IMPORTS
import {
  signInWithPopup,
  OAuthProvider,
  fetchSignInMethodsForEmail,
  linkWithCredential,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut
} from "firebase/auth";

import { db } from "../firebase/config";


export default function LoginPage({ auth }) {
  const [successMsg, setSuccessMsg] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [showForgot, setShowForgot] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Rol - Sayfa yönlendirme
  const redirectByRole = (role) => {
    switch (role) {
      case "UserAdmin":
        navigate("/usermanagement", { replace: true });
        break;
      case "admin":
        navigate("/admin", { replace: true });
        break;
      case "user":
        navigate("/calendaruser", { replace: true });
        break;
      default:
        setError("Bu hesap için rol bulunamadı.");
    }
  };

  // -----------------------------------------------------
  // 🔐 Email / Username ile Login
  // -----------------------------------------------------
// -----------------------------------------------------
// 🔐 Email / Username ile Login + Admin Seçimi
// -----------------------------------------------------
const handleLogin = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
    // ----------------------------------------------------
    // 1) Email normalizasyonu
    // ----------------------------------------------------
    let emailInput = username.replace(/\s+/g, "").trim().toLowerCase();

    if (!emailInput.includes("@")) {
      emailInput = 
        emailInput === "admin"
          ? "admin@acunmedya.com"
          : `${emailInput}@acunmedya.com`;
    }

    console.log("📥 Girilen kullanıcı adı:", username);
    console.log("📧 Normalize edilmiş emailInput:", emailInput);

    // ----------------------------------------------------
    // 2) Firebase AUTH login
    // ----------------------------------------------------
    const res = await signInWithEmailAndPassword(auth, emailInput, password);

    // ----------------------------------------------------
    // 3) Firestore sorgusu
    // ----------------------------------------------------
    const q = query(collection(db, "users"), where("email", "==", emailInput));
    const snap = await getDocs(q);

    console.log("📦 Firestore döküman sayısı:", snap.size);

    snap.forEach((d) => {
      console.log("➡️ bulunan kayıt:", d.data());
    });

    if (snap.empty) {
      setError("Hesap Firestore'da bulunamadı.");
      await signOut(auth);
      return;
    }

    // ----------------------------------------------------
    // 4) Admin varsa admin'i seç
    // ----------------------------------------------------
    let selectedUser = snap.docs[0].data();

    snap.forEach((doc) => {
      const d = doc.data();
      if (d.role === "UserAdmin" || d.role === "admin") {
        selectedUser = d;
      }
    });

    console.log("🎯 Seçilen kullanıcı rolü:", selectedUser.role);

    if (selectedUser.disabled === true) {
      await signOut(auth);
      setError("Bu hesap devre dışı bırakılmıştır.");
      return;
    }

    // ----------------------------------------------------
    // 5) Rol bazlı yönlendirme
    // ----------------------------------------------------
    redirectByRole(selectedUser.role || "user");
  } catch (err) {
    console.log("🔥 HATA:", err);
    setError("Login failed: " + err.message);
  } finally {
    setLoading(false);
  }
};



  // -----------------------------------------------------
  // 🔵 Microsoft Login
  // -----------------------------------------------------
// -----------------------------------------------------
// 🔵 Microsoft Login + Admin Seçimi
// -----------------------------------------------------
const handleMicrosoftLogin = async () => {
  setError("");
  setLoading(true);

  try {
    const provider = new OAuthProvider("microsoft.com");
    provider.setCustomParameters({ prompt: "select_account" });

    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    const emailKey = user.email.toLowerCase();

    // ----------------------------------------------------
    // 🔍 Firestore'da aynı email ile tüm kullanıcıları çek
    // ----------------------------------------------------
    const q = query(collection(db, "users"), where("email", "==", emailKey));
    const snap = await getDocs(q);

    // Kullanıcı ilk defa Microsoft ile giriş yapıyorsa Firestore kaydı oluştur
    if (snap.empty) {
      const ref = doc(db, "users", emailKey);
      await setDoc(ref, {
        uid: user.uid,
        email: emailKey,
        displayName: user.displayName || "",
        role: "user",
        disabled: false,
        createdAt: new Date().toISOString(),
      });

      redirectByRole("user");
      return;
    }

    // ----------------------------------------------------
    // 🔥 Admin varsa admin'i seç
    // ----------------------------------------------------
    let selectedUser = snap.docs[0].data();
    snap.forEach((doc) => {
      const d = doc.data();
      if (d.role === "admin" || d.role === "UserAdmin") {
        selectedUser = d;
      }
    });

    if (selectedUser.disabled === true) {
      await signOut(auth);
      setError("Bu hesap devre dışı bırakılmıştır.");
      return;
    }

    redirectByRole(selectedUser.role || "user");
  } catch (err) {
    setError("Microsoft Login Failed: " + err.message);
  } finally {
    setLoading(false);
  }
};


  // -----------------------------------------------------
  // 🔁 Şifre Sıfırlama
  // -----------------------------------------------------
const handleForgotPassword = async () => {
  setError("");
  setLoading(true);

  try {
    const email = resetEmail.trim().toLowerCase();

    if (!email) {
      setError("Please enter an email address.");
      setLoading(false);
      return;
    }

    // 🔍 Firestore'da email ile arama
    const q = query(
      collection(db, "users"),
      where("email", "==", email)
    );

    const snap = await getDocs(q);

    if (snap.empty) {
      setError("No user found with this email.");
      setLoading(false);
      return;
    }

    const userData = snap.docs[0].data();

    if (userData.disabled === true) {
      setError("This account is disabled.");
      setLoading(false);
      return;
    }

    // 📩 Reset mail gönder
    await sendPasswordResetEmail(auth, email);

    // Modal kapat
    setShowForgot(false);
    setResetEmail("");

    setSuccessMsg(
      "A password reset email has been sent. Please check your inbox and spam folder. If you do not receive it, contact your administrator."
    );

    setTimeout(() => setSuccessMsg(""), 10000);

  } catch (err) {
    setError("Password reset failed: " + err.message);
  } finally {
    setLoading(false);
  }
};



  // -----------------------------------------------------
  // UI
  // -----------------------------------------------------
  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="Acun Medya Logo" className="login-logo" />
        <h2 className="login-title">Sign in to Calendar</h2>

        {/* Login Form */}
        <form className="login-form" onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Username or Email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <div className="divider">or</div>

        {/* Microsoft Login */}
        <button
          className="btn-microsoft"
          onClick={handleMicrosoftLogin}
          disabled={loading}
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg"
            alt="Microsoft Logo"
          />
          <span>Sign in with Microsoft</span>
        </button>
{successMsg && (
  <div className="success-banner">
    {successMsg}
  </div>
)}
        {/* Şifremi Unuttum */}
 <button
  className="btn-forgot"
  onClick={() => setShowForgot(true)}
>
  Forgot your password?
</button>
{showForgot && (
  <div className="modal-overlay" onClick={() => setShowForgot(false)}>
    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      <h3>Password Reset</h3>

      <input
        type="email"
        placeholder="Enter your email"
        value={resetEmail}
        onChange={(e) => setResetEmail(e.target.value.toLowerCase())}
        required
      />

      <button
        className="btn-primary modal-btn"
        onClick={handleForgotPassword}
        disabled={loading}
      >
        {loading ? "Sending..." : "Send Reset Link"}
      </button>

      <button
        className="btn-cancel modal-btn"
        onClick={() => setShowForgot(false)}
      >
        Close
      </button>
    </div>
  </div>
)}



        {error && <p className="login-error">{error}</p>}
      </div>
    </div>
  );
}
